import { TAuthenticationModalType } from '../../types/authenticationModal';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ERequestAuthenticationActionType {
  Modal = 'requestAuthentication/modal',
}

type TRequestAuthenticationModal = ITypedReduxAction<ERequestAuthenticationActionType.Modal, TAuthenticationModalType>;

export type TRequestAuthentication = TRequestAuthenticationModal;
